package de.oevbs.kunde.kundenportal2

import de.oevbs.kunde.kundenportal2.components.headerImageLayout
import de.oevbs.kunde.kundenportal2.components.textualButton
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.navigation.components.subPagesOverview
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext

fun RenderContext.welcomePage(page: Page) {
    headerImageLayout {
        title(page.linkTitle)
        backgroundImage = "images/backgrounds/willkommen.jpg"
        content {
            subPagesOverview(page) {
                description {
                    p {
                        +"""Hier finden Sie unsere Self-Services, mit denen Sie eigenständig Anpassungen an Ihren Daten
                            | vornehmen können. Sie können beispielsweise """.trimMargin()

                        textualButton("Wohnort oder Telefonnummer aktualisieren") handledBy {
                            Pages.myDataContact.visit()
                        }

                        +", im Sinne der Nachhaltigkeit Ihre "

                        textualButton("Dokumente auf Mailversand umstellen") handledBy {
                            Pages.inboxDelivery.visit()
                        }

                        +", ganz praktisch ein "

                        textualButton("Fahrzeug abmelden") handledBy {
                            Pages.serviceCarInsuranceDeregister.visit()
                        }

                        +"  und noch vieles mehr. Laden Sie außerdem die "

                        textualButton("digitale Kfz-Servicekarte") handledBy {
                            Pages.serviceCarInsuranceDigiCard.visit()
                        }
                        +" für Ihr Smartphone herunter - so haben Sie Ihre Versicherungsdaten jederzeit parat."
                    }
                }
            }
        }
    }
}